<template>
	<el-drawer :modal="false"  title="Reassign Lead History" name="drawer-reassign-history" :visible.sync="show_drawer" class="drawer-reassign-history"
		size="50%">
		<b-container>
			<b-row>
				<b-col cols="12">
					<b-card no-body class="p-3">
						<b-row>
							<b-col cols="12">
								<h5>Reassignment Lead Setting</h5>
							</b-col>
							<b-col cols="12">
								<b-form-group label="Exclude lead with main status">
										<el-select v-model="formData.setting_json.exclude_reassign_main_status" placeholder="Choose Main Status" multiple filterable :disabled="is_readonly">
												<!-- <el-option value="">All</el-option> -->
														<el-option
																v-for="item in mainStatusList"
																:key="item.status_id"
																:label="item.status"
																:value="item.status_id"
																>
														</el-option>
										</el-select>
								</b-form-group>
							</b-col>
							<b-col cols="12">
								<b-form-group label="Exclude lead with sub status">
										<el-select v-model="formData.setting_json.exclude_reassign_sub_status" placeholder="Choose Sub Status" multiple filterable :disabled="is_readonly">
												<!-- <el-option value="">All</el-option> -->
														<el-option
																v-for="item in subStatusList"
																:key="item.status_id"
																:label="item.status"
																:value="item.status_id"
																>
														</el-option>
										</el-select>
								</b-form-group>
							</b-col>
							<b-col cols="12">
								<b-form-group label="Reshuffle Only Channel">
										<el-select v-model="formData.setting_json.lead_reassign_only_channel_ids" placeholder="Choose Only Channel Reshuffle" multiple filterable :disabled="is_readonly">
												<!-- <el-option value="">All</el-option> -->
														<el-option
																v-for="item in list_channels"
																:key="item.channel_id"
																:label="item.name"
																:value="item.channel_id"
																>
														</el-option>
										</el-select>
								</b-form-group>
							</b-col>
							<b-col cols="12" v-if="!is_readonly">
								<div class="d-flex justify-content-between">
									<b-button variant="primary" @click="saveSetting">Save Setting</b-button>
									<b-button variant="danger"  @click="runManualReassign">Manual Run Reassign</b-button>
								</div>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
				<b-col cols="12">
					<b-table-simple responsive bordered>
            <b-thead>
                <b-tr>
									<b-th>No.</b-th>
									<b-th>Reassign Date</b-th>
									<b-th>Total Summary</b-th>
									<b-th>Method</b-th>
									<b-th>Status</b-th>
									<b-th>Detail</b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="!_gHlp.isEmpty(tableData)">
                <b-tr v-for="(item, index) in tableData" :key="index" class="text-center">
                    <b-td>{{ index + 1 }}</b-td>
                    <b-td>{{ item.run_start_at | dateTimeFormatString }}</b-td>
                    <b-td class="text-left">
											<ul>
												<li>Total Recycle Leads : {{ item.total_leads }}</li>
												<li>Total Reassigned Leads : {{ item.total_reassigned }}</li>
												<li>Total Back To Master Leads : {{ item.total_leads - item.total_reassigned}}</li>
											</ul>
										</b-td>
                    <b-td>{{ item.action_type }}</b-td>
										<b-td>{{ item.process_status }}</b-td>
                    <b-td>
											<el-button v-if="!_gHlp.isEmpty(item.attachment_detail)" type="text" @click="_gFile.downloadFromAttachmnetService(item.attachment_detail.attachment_id, item.attachment_detail.original_filename)">Download Detail</el-button>
											<span v-else>-</span>
											<small class="d-block text-danger text-wrap" v-if="!_gHlp.isEmpty(item.error_message)">{{ item.error_message }}</small>
										</b-td>
                </b-tr>
            </b-tbody>
						<b-tbody v-else>
                <b-tr>
                    <b-td colspan="6"><i>No Record</i></b-td>
                </b-tr>
            </b-tbody>

        	</b-table-simple>
				</b-col>
			</b-row>

		</b-container>
	</el-drawer>
</template>
<script>
import { Drawer, Select, Option, Button } from 'element-ui'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useLeadStore } from '@/stores/leadStore'
import { useLookupStore } from '@/stores/lookupStore'
import { mapState, mapActions } from 'pinia'
import {
	axios,
	services,
	getHeader,
	swal
} from '@/assets/js/httpImports.js'
export default {
	props: {
		mainStatusList: {
			type: Array,
		},
		subStatusList: {
			type: Array,
		}
	}, 
	components: {
		[Drawer.name]: Drawer,
		[Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button
	},
	computed: {
		...mapState(useAccessControlStore,['corporateDetail']),
		...mapState(useLookupStore,['list_channels']),
		is_readonly(){
			return !_gHlp.checkAccess(['role_it_admin']);
		}
	},
	async created() {
		this.getActiveCorporate(_gAuth.activeCorporateId());
		await this.fetchLeadReassign();
	},
	mounted() {

	},
	watch:{
		corporateDetail(newVal){
			if(!_gHlp.isEmpty(newVal)){
				this.formData.id = newVal.id;
				this.formData.name = newVal.name;
				this.formData.setting_json.exclude_reassign_main_status = _gHlp.getValue(newVal,'setting_json.exclude_reassign_main_status',[])
				this.formData.setting_json.exclude_reassign_sub_status = _gHlp.getValue(newVal,'setting_json.exclude_reassign_sub_status',[])
				this.formData.setting_json.lead_reassign_only_channel_ids = _gHlp.getValue(newVal,'setting_json.lead_reassign_only_channel_ids',[])
			}
		}
	},	
	data() {
		return {
			show_drawer: false,
			tableData:[],
			formData:{
				id:'',
				name:'',
				setting_json:{
					exclude_reassign_main_status:[],
					exclude_reassign_sub_status:[],
					lead_reassign_only_channel_ids:[],
				}
			}
		}
	},
	methods: {
		...mapActions(useAccessControlStore, ['getActiveCorporate','updateCorporates']),
		...mapActions(useLeadStore, ['checkReassignment','getLeadReassignments','runLeadReassgnments']),
		showDrawer() {
			this.show_drawer = !this.show_drawer;
		},
		closeDrawer() {
			this.show_drawer = false;
			this.$emit('close');
		},
		fetchLeadReassign() {
			this.getLeadReassignments().then(res => {
				this.tableData = res;
			})
			.catch(e => {
				_gNotif.errorFunction(e)
			})
		},
		async saveSetting(){
			let resp = await this.updateCorporates(this.formData.id,this.formData);
			if(!_gHlp.isEmpty(resp)){
				_gNotif.notifySuccess('<b>Status </b> - Setting has been updated');
			}
		},
		runManualReassign(){
			swal.fire({
					title: 'Are you sure?',
					text: "This action will run reassign lead to users",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Proceed'
			}).then(async (result) => {
					if (result.isConfirmed) {
						if(this.runLeadReassgnments()){
							_gNotif.notifySuccess('<b>Status </b> - Reassign process has running, system will send to your corporate owner email');
							this.fetchLeadReassign();
							this.checkReassignment();
						}
					}
					
			})

		}
	}
}
</script>